'use client'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

/**
 * Wraps children in the reCAPTCHA v3 provider when a site key is configured.
 * Falls back to rendering children directly so forms keep working
 * (without bot protection) if NEXT_PUBLIC_RECAPTCHA_SITE_KEY isn't set.
 */
export function RecaptchaProvider({ children }) {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

  if (!siteKey) {
    return children
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      {children}
    </GoogleReCaptchaProvider>
  )
}
